import { ApiGet,ApiPost,ApiPut,ApiDelete } from './Common.ts'

import {  GetWebConnectorUrl, GetOrderEntryConnectorUrl } from '../stores/SettingsStore.ts'

import type {
  IContactResponse,
  IAoeContact,
  IAoeContactOrderList,
  IAoeContactUpdate,
  IAddressBookCreateRequest,
  IAddressBookCreateResponse,
  IHostPortalAddressBookCreateRequest,
  IAddressBookFindRequest,
  IAddressBookFindListResponse,
  IAoeContactInfo,
  IAoeContactSocials,
  IAoeContactNotes,
  IAoeContactNote,
  IAoeContactNoteUpdate,
} from '../types/AddressBookTypes.ts'

export async function getAddressBook(): Promise<IContactResponse> {
  const url = await GetWebConnectorUrl('PwsAddressBookGetList')
  return ApiPost(url,{} )
}

export async function deleteAddressBookEntry(addressBookId: number, beeNumber: number) {

  const url = await GetWebConnectorUrl('PwsAddressBookDelete')

      return ApiDelete(url,{addressBookId,beeNumber} )
}

export async function UpdateAddressBook(contact:IAoeContactUpdate): Promise<IAoeContact> {
  const url = await GetWebConnectorUrl('PwsAddressBookGeneralSave')
  return ApiPut(url,contact )
}

export async function getContactDetails(addressBookId: number): Promise<IAoeContact> {
  const url = await GetWebConnectorUrl('PwsAddressBookGeneralGet')
  return ApiGet(url, { addressBookId })
}

export async function FindAddressBook(request: IAddressBookFindRequest): Promise<IAddressBookFindListResponse> {
  const url = await GetOrderEntryConnectorUrl('AddressBookFind')
  return await ApiGet(url, request)
}


export async function CreateAddressBook(request: IAddressBookCreateRequest): Promise<IAddressBookCreateResponse> {
  const url = await GetOrderEntryConnectorUrl('AddressBookCreate')
  return await ApiPost(url, request)
}

export async function CreateHostPortalAddressBook(request: IHostPortalAddressBookCreateRequest): Promise<IAddressBookCreateResponse> {
  const url = await GetOrderEntryConnectorUrl('HostPortalAddressBookCreate')
  return await ApiPost(url, request)
}

export async function getContactOrders(addressBookId: number): Promise<IAoeContactOrderList> {
  const url = await GetOrderEntryConnectorUrl('AddressBookOrdersGetList')
  return ApiGet(url, { addressBookId })
}

export async function getContactInformation(addressBookId: number): Promise<IAoeContactInfo> {
  const url = await GetWebConnectorUrl('PwsAddressBookInformationGet')
  return ApiGet(url, { addressBookId })
}

export async function UpdateAddressBookInfo(contact:IAoeContactInfo): Promise<IAoeContactInfo> {
  const url = await GetWebConnectorUrl('PwsAddressBookInformationSave')
  return ApiPut(url,contact )
}

export async function getContactSocials(addressBookId: number): Promise<IAoeContactSocials> {
  const url = await GetWebConnectorUrl('PwsAddressBookSocialMediaGet')
  return ApiGet(url, { addressBookId })
}

export async function UpdateAddressBookSocials(contact:IAoeContactSocials): Promise<IAoeContactSocials> {
  const url = await GetWebConnectorUrl('PwsAddressBookSocialMediaSave')
  return ApiPut(url,contact )
}

export async function getContactNotes(addressBookId: number): Promise<IAoeContactNotes> {
  const url = await GetWebConnectorUrl('PwsAddressBookNoteGetList')
  return ApiGet(url, { addressBookId })
}

export async function UpdateAddressBookNotes(contact:IAoeContactNoteUpdate): Promise<IAoeContactNote> {
  const url = await GetWebConnectorUrl('PwsAddressBookNoteSave')
  return ApiPut(url,contact )
}

export async function LinkAddressBookToCustomer(addressBookId: number, customerBeeNumber: number): Promise<{ success: boolean }> {
  const url = await GetOrderEntryConnectorUrl('AddressBookCustomerLink')
  return ApiPut(url, { addressBookId, customerBeeNumber })
}
